var webooker_utils = webooker_utils || {};

(function (ns) {

    ns.ColorUtils = function ColorUtils() {

    }

    ns.ColorUtils.prototype.intToRgb = function(intColor) {
        intColor >>>= 0;
        var b = intColor & 0xFF,
            g = (intColor & 0xFF00) >>> 8,
            r = (intColor & 0xFF0000) >>> 16;
        return "rgb(" + [r, g, b].join(",") + ")";
    }

    ns.ColorUtils.prototype.rgbToInt = function(rgbColor) {
        var regexRgb = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/g;
        var match = regexRgb.exec(rgbColor);

        return (parseInt(match[1]) << 16) +
               (parseInt(match[2]) << 8) +
               (parseInt(match[3]));
    }

})(webooker_utils);